import classNames from 'classnames';
import { attempt, Heading } from 'yoso';
import { Modal, ModalProps } from '~/components/Modal/Modal';
import modalStyles from '~/components/Modal/Modal.module.scss';
import popupStyles from './Popup.module.scss';

export const styles = { ...modalStyles, ...popupStyles };
export type PopupProps = Omit<
  ModalProps,
  'dismissButton' | 'dismissText' | 'confirmButton' | 'confirmText'
>;

export const Popup = ({ className, title, description, children, ...props }: PopupProps) => (
  <Modal
    className={classNames(popupStyles.root, className)}
    {...props}
    confirmButton={null}
    dismissButton={null}>
    {(value) => (
      <>
        {title && (
          <Heading level={5} className={classNames(popupStyles.heading, modalStyles.heading)}>
            {title}
          </Heading>
        )}
        {description && (
          <p className={classNames(popupStyles.description, modalStyles.description)}>
            {description}
          </p>
        )}
        {attempt(children, value)}
      </>
    )}
  </Modal>
);
